import burger from "../assets/menu.svg";
import close from "../assets/close-square.svg";
import logo from "../assets/logo.svg";
import { useState } from "react";
function Navbar() {
  const [isClosed, setIsClosed] = useState(true);
  const nav = [
    { name: "about", id: 1 },
    { name: "skills", id: 2 },
    { name: "projects", id: 3 },
  ];
  return (
    <header className="el-container-xl min-h-[10vh] py-5 flex items-center justify-between ">
      <img className="pb-1" src={logo} alt="" />
      <img
        onClick={() => setIsClosed(false)}
        className="cursor-pointer sm:hidden "
        src={burger}
        alt="menu"
      />
      <nav
        onClick={() => setIsClosed(true)}
        className={`sm:block burger-menu ${!isClosed ? "block" : "hidden"}`}
      >
        <img className="ml-auto mt-4 cursor-pointer sm:hidden" src={close} alt="close" />
        <ul className=" sm:flex sm:items-center">
          {nav.map((item) => (
            <li key={item.id} className="pt-6 sm:pt-0 sm:pl-7">
              <a className="hover:text-gray-300" href={`#${item.name}`}>
                {item.name}
              </a>
            </li>
          ))}
          <li className="pt-7 sm:pt-0 sm:pl-7">
            <a
              href="#contact"
              className="w-28 h-11 py-2 px-2 rounded text-background bg-primary font-Poppins el-buttonType"
            >
              contact
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Navbar;
